import React from "react";
import { isMobile } from "../helperFunc";
import Certified from "./../Images/CommonImages/Certified.png";
import HeadLines from "./HeadLines";
import style from "./style.module.css";
const CertifiedComponent = ({
  className,
  headLineClassName,
  mobileCSS = isMobile
    ? `font-weight500 line-height12 letterSpacing004 font-size10`
    : `font-weight400 line-height19 letterSpacing05 font-size16`,
  iconHeightWidth = style["iconHeightWidth14"],
}) => {
  return (
    <div className={className}>
      <img src={Certified} alt="" className={iconHeightWidth} />
      <span
        className={`display-inline-block ${
          isMobile ? style["padding-left6"] : "padding-left4"
        }`}
      >
        <HeadLines
          text="Arya Certified"
          className={`colorAccent2 ${mobileCSS} ${headLineClassName}`}
        />
      </span>
    </div>
  );
};
export default CertifiedComponent;
